import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/common/tabs'
import type { FixedTermMarket } from '@/utils/internalAppSdk'
import { FixedTermMarketDetails } from './fixedTermMarketDetails'
import { FixedTermMarketProjectedYield } from './fixedTermMarketProjectedYield'
import { FixedTermMarketRelatedMarkets } from './fixedTermMarketRelatedMarkets'
import { FixedTermMarketYieldAssumptions, FixedTermMarketYieldExplanation } from './fixedTermMarketYieldExplanation'

const FIXED_TERM_MARKET_TAB_VALUES = {
  overview: 'overview',
  position: 'position',
} as const

interface Props {
  market: FixedTermMarket
}

export const FixedTermMarketContent = ({ market }: Props) => (
  <Tabs defaultValue={FIXED_TERM_MARKET_TAB_VALUES.overview} className="overflow-hidden">
    <div className="flex flex-col gap-4">
      <TabsList variant="line" aria-label="Fixed-term market sections">
        <TabsTrigger variant="line" value={FIXED_TERM_MARKET_TAB_VALUES.overview}>
          Overview
        </TabsTrigger>
        <TabsTrigger variant="line" value={FIXED_TERM_MARKET_TAB_VALUES.position} disabled>
          Your position &amp; activity
        </TabsTrigger>
      </TabsList>
      <TabsContent value={FIXED_TERM_MARKET_TAB_VALUES.overview}>
        <div className="flex flex-col gap-4">
          <FixedTermMarketProjectedYield market={market} />
          <FixedTermMarketYieldAssumptions market={market} />
          <div className="grid gap-4 md:grid-cols-2">
            <FixedTermMarketYieldExplanation />
            <FixedTermMarketDetails market={market} />
          </div>
          <FixedTermMarketRelatedMarkets market={market} />
        </div>
      </TabsContent>
      <TabsContent value={FIXED_TERM_MARKET_TAB_VALUES.position} />
    </div>
  </Tabs>
)
